
type MimeTypeData = {
  faExtension: string,
  description: string,
  fileExtension?: string[],
};

interface MimeTypeMap {
  [key: string]: MimeTypeData;
}

const typeAndSubtype: MimeTypeMap = {
  'audio/aac': { faExtension: '-file-audio', description: 'AAC audio', fileExtension: ['aac'] },
  'application/x-abiword': { faExtension: '-file-alt', description: 'AbiWord document', fileExtension: ['abw'] },
  'application/x-freearc': { faExtension: '-file-archive', description: 'Archive document (multiple files embedded)', fileExtension: ['arc'] },
  'video/x-msvideo': { faExtension: '-file-video', description: 'AVI: Audio Video Interleave', fileExtension: ['avi'] },
  'application/vnd.amazon.ebook': { faExtension: '-book', description: 'Amazon Kindle eBook format', fileExtension: ['azw'] },
  'application/octet-stream': { faExtension: '-file', description: 'Binary data', fileExtension: ['bin'] },
  'image/bmp': { faExtension: '-file-image', description: 'Bitmap image', fileExtension: ['bmp'] },
  'application/x-bzip': { faExtension: '-file-archive', description: 'BZip archive', fileExtension: ['bz'] },
  'application/x-bzip2': { faExtension: '-file-archive', description: 'BZip2 archive', fileExtension: ['bz2'] },
  'application/x-csh': { faExtension: '-file-code', description: 'C-Shell script', fileExtension: ['csh'] },
  'text/css': { faExtension: '-file-code', description: 'Cascading Style Sheet (CSS)', fileExtension: ['css'] },
  'text/csv': { faExtension: '-file-csv', description: 'Comma-separated values (CSV)', fileExtension: ['csv'] },
  'application/msword': { faExtension: '-file-word', description: 'Microsoft Word document', fileExtension: ['doc'] },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': { faExtension: '-file-word', description: 'Microsoft Word document (OpenXML)', fileExtension: ['docx'] },
  'application/vnd.ms-fontobject': { faExtension: '-fa-font', description: 'MS Embedded OpenType fonts', fileExtension: ['eot'] },
  'application/epub+zip': { faExtension: '-book', description: 'Electronic publication (EPUB)', fileExtension: ['epub'] },
  'application/gzip': { faExtension: '-file-archive', description: 'GZip Compressed Archive', fileExtension: ['gz'] },
  'image/gif': { faExtension: '-file-image', description: 'GIF image', fileExtension: ['gif'] },
  'text/html': { faExtension: '-file-code', description: 'HyperText Markup Language (HTML)', fileExtension: ['html', 'htm'] },
  'image/vnd.microsoft.icon': { faExtension: '-icons', description: 'Icon', fileExtension: ['ico'] },
  'text/calendar': { faExtension: '-calendar-alt', description: 'iCalendar', fileExtension: ['ics'] },
  'application/java-archive': { faExtension: '-file-archive', description: 'Java Archive', fileExtension: ['jar'] },
  'image/jpeg': { faExtension: '-file-image', description: 'JPEG image', fileExtension: ['jpeg', 'jpg'] },
  'text/javascript': { faExtension: '-file-code', description: 'JavaScript', fileExtension: ['js'] },
  'application/json': { faExtension: '-file-code', description: 'JSON format data', fileExtension: ['json'] },
  'application/ld+json': { faExtension: '-file-code', description: 'JSON-LD format data', fileExtension: ['jsonld'] },
  'audio/midi': { faExtension: '-file-audio', description: 'Musical Instrument Digital Interface (MIDI)', fileExtension: ['mid', 'midi'] },
  'audio/x-midi': { faExtension: '-file-audio', description: 'Musical Instrument Digital Interface (MIDI)', fileExtension: ['mid', 'midi'] },
  'audio/mpeg': { faExtension: '-file-audio', description: 'MP3 audio', fileExtension: ['mp3'] },
  'video/mpeg': { faExtension: '-file-video', description: 'MPEG video', fileExtension: ['mpeg'] },
  'video/mp4': { faExtension: '-file-video', description: 'MP4 video', fileExtension: ['mp4'] },
  'application/vnd.apple.installer+xml': { faExtension: '-file-alt', description: 'Apple Installer Package', fileExtension: ['mpkg'] },
  'application/vnd.oasis.opendocument.presentation': { faExtension: '-file-powerpoint', description: 'OpenDocument presentation document', fileExtension: ['odp'] },
  'application/vnd.oasis.opendocument.spreadsheet': { faExtension: '-file-spreadsheet', description: 'OpenDocument spreadsheet document', fileExtension: ['ods'] },
  'application/vnd.oasis.opendocument.text': { faExtension: '-file-alt', description: 'OpenDocument text document', fileExtension: ['odt'] },
  'audio/ogg': { faExtension: '-file-audio', description: 'OGG audio', fileExtension: ['oga'] },
  'video/ogg': { faExtension: '-file-video', description: 'OGG video', fileExtension: ['ogv'] },
  'application/ogg': { faExtension: '-file', description: 'OGG', fileExtension: ['ogx'] },
  'audio/opus': { faExtension: '-file-audio', description: 'Opus audio', fileExtension: ['opus'] },
  'font/otf': { faExtension: '-fa-font', description: 'OpenType font', fileExtension: ['otf'] },
  'image/png': { faExtension: '-file-image', description: 'PNG image', fileExtension: ['png'] },
  'application/pdf': { faExtension: '-file-pdf', description: 'Adobe Portable Document Format (PDF)', fileExtension: ['pdf'] },
  'application/x-httpd-php': { faExtension: '-file-code', description: 'Hypertext Preprocessor (Personal Home Page)', fileExtension: ['php'] },
  'application/vnd.ms-powerpoint': { faExtension: '-file-powerpoint', description: 'Microsoft PowerPoint', fileExtension: ['ppt'] },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': { faExtension: '-file-powerpoint', description: 'Microsoft PowerPoint (OpenXML)', fileExtension: ['pptx'] },
  'application/vnd.rar': { faExtension: '-file-archive', description: 'RAR archive', fileExtension: ['rar'] },
  'application/rtf': { faExtension: '-file-alt', description: 'Rich Text Format (RTF)', fileExtension: ['rtf'] },
  'application/x-sh': { faExtension: '-file-code', description: 'Bourne shell script', fileExtension: ['sh'] },
  'image/svg+xml': { faExtension: '-file-image', description: 'Scalable Vector Graphics (SVG)', fileExtension: ['svg'] },
  'application/x-shockwave-flash': { faExtension: '-file', description: 'Adobe Flash document', fileExtension: ['swf'] },
  'application/x-tar': { faExtension: '-file-archive', description: 'Tape Archive (TAR)', fileExtension: ['tar'] },
  'image/tiff': { faExtension: '-file-image', description: 'TIF image', fileExtension: ['tif', 'tiff'] },
  'video/mp2t': { faExtension: '-file-video', description: 'MPEG transport stream', fileExtension: ['ts'] },
  'font/ttf': { faExtension: '-fa-font', description: 'TrueType Font', fileExtension: ['ttf'] },
  'text/plain': { faExtension: '-file-alt', description: 'Text', fileExtension: ['txt'] },
  'application/vnd.visio': { faExtension: '-project-diagram', description: 'Microsoft Visio', fileExtension: ['vsd'] },
  'audio/wav': { faExtension: '-file-audio', description: 'Waveform Audio', fileExtension: ['wav'] },
  'audio/webm': { faExtension: '-file-audio', description: 'WEBM audio', fileExtension: ['weba'] },
  'video/webm': { faExtension: '-file-video', description: 'WEBM video', fileExtension: ['webm'] },
  'image/webp': { faExtension: '-file-image', description: 'WEBP image', fileExtension: ['webp'] },
  'font/woff': { faExtension: '-fa-font', description: 'Web Open Font Format (WOFF)', fileExtension: ['woff'] },
  'font/woff2': { faExtension: '-fa-font', description: 'Web Open Font Format (WOFF)', fileExtension: ['woff2'] },
  'application/xhtml+xml': { faExtension: '-file-code', description: 'XHTML', fileExtension: ['xhtml'] },
  'application/vnd.ms-excel': { faExtension: '-file-excel', description: 'Microsoft Excel', fileExtension: ['xls'] },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': { faExtension: '-file-excel', description: 'Microsoft Excel (OpenXML)', fileExtension: ['xlsx'] },
  'application/xml': { faExtension: '-file-code', description: 'XML data', fileExtension: ['xml'] },
  'text/xml': { faExtension: '-file-code', description: 'XML data', fileExtension: ['xml'] },
  'application/vnd.mozilla.xul+xml': { faExtension: '-file-code', description: 'XUL', fileExtension: ['xul'] },
  'application/zip': { faExtension: '-file-archive', description: 'ZIP archive', fileExtension: ['zip'] },
  'video/3gpp': { faExtension: '-file-video', description: '3GPP video container', fileExtension: ['3gp'] },
  'audio/3gpp': { faExtension: '-file-audio', description: '3GPP audio container', fileExtension: ['3gp'] },
  'video/3gpp2': { faExtension: '-file-video', description: '3GPP2 video container', fileExtension: ['3g2'] },
  'audio/3gpp2': { faExtension: '-file-audio', description: '3GPP2 audio container', fileExtension: ['3g2'] },
  'application/x-7z-compressed': { faExtension: '-file-archive', description: '7-zip archive', fileExtension: ['7z'] },
};

const justType: {[key: string]: MimeTypeData} = {
  application: { faExtension: '-file', description: 'Miscellaneous' },
  audio: { faExtension: '-file-audio', description: 'Audio' },
  font: { faExtension: '-fa-font', description: 'Font' },
  image: { faExtension: '-file-image', description: 'Image' },
  text: { faExtension: '-file-alt', description: 'Text' },
  video: { faExtension: '-file-video', description: 'Video' },
};

const fallback: MimeTypeData = { faExtension: '-file', description: 'Miscellaneous' };

type MimeTypeOptions = {
  /** Default: false */
  includeDescription?: boolean;
  /** Default: 'fas' */
  faType?: string;
}

/**
 * Configurable class with handy methods for detecting mime types and generating
 * appropriate FA icons
 */
export class MimeTypeIcons {
  includeDescription: boolean;
  faType: string;

  constructor(options?: MimeTypeOptions) {
    this.includeDescription = options?.includeDescription ?? false;
    this.faType = options?.faType ?? 'fas';
  }

  iconElement(data: MimeTypeData): HTMLElement {
    const element = document.createElement('i');
    if (this.includeDescription) {
      element.setAttribute('aria-label', data.description);
    } else {
      element.setAttribute('aria-hidden', 'true');
    }
    element.className = `${this.faType} fa${data.faExtension}`;
    return element;
  }

  /**
   * Get the MIME Type data object, or nearest available by MIME Type
   */
  getDataForMimeType(mimeType?: string): MimeTypeData {
    if (typeof mimeType !== 'string') {
      console.warn(`${mimeType} is not a string`);
      return fallback;
    }
    const theType = mimeType.split('/')[0];
    if (typeAndSubtype[mimeType] !== undefined) {
      return typeAndSubtype[mimeType];
    } if (theType && justType[theType]) {
      return justType[theType];
    }
    return fallback;
  }

  /**
   * Get the MIME Type data by file extension. Works with full file name or just extension,
   * and is case insensitive
   */
  getDataForFileExtension(fileExtension: string): MimeTypeData {
    if (typeof fileExtension !== 'string') {
      console.warn(`${fileExtension} is not a string`);
      return fallback;
    }
    const splitFileExtension = fileExtension.split('.');
    const trimmedExtension = splitFileExtension[splitFileExtension.length - 1].trim().toLowerCase();
    const typeKey = Object.keys(typeAndSubtype).find(
      (key) => typeAndSubtype[key].fileExtension.includes(trimmedExtension),
    );
    return typeKey ? typeAndSubtype[typeKey] : fallback;
  }

  /**
   * Use this function to generate an icon element if you expect your data to be a correct MIME type
   * @param {string} mimeType - Validates that it's a string of the form "type/subtype",
   * throws error if not
   */
  iconFromMimeType(mimeType: string): HTMLElement {
    if (typeof mimeType !== 'string' || mimeType.split('/').length !== 2) {
      throw new Error(`${mimeType} was not a correctly formatted MIME type string (i.e. 'type/subtype'`);
    }
    return this.iconElement(this.getDataForMimeType(mimeType));
  }

  /**
   * Use this if you know you're dealing with a filename and can't get the mimetype. It will
   * return our best guess as to what icon this file should have
   */
  iconFromFilename(filename: string): HTMLElement {
    if (typeof filename !== 'string') {
      throw new Error(`${filename} was not a string`);
    }
    return this.iconElement(this.getDataForFileExtension(filename));
  }

  /**
   * Use this if your data is unreliable in some way. We'll do our best to work out
   * what this is. The worst you'll get is a generic file icon.
   */
  icon(inputString?: string): HTMLElement {
    const asMimeTypeResult = this.getDataForMimeType(inputString);
    if (asMimeTypeResult !== fallback) {
      return this.iconElement(asMimeTypeResult);
    }
    return this.iconElement(this.getDataForFileExtension(inputString));
  }

  /**
   * Will do its best to find a mimetype for the supplied filename.
   * Returns undefined if unsuccessful.
   */
  mimeTypeFromFileName(fileName: string): string | undefined {
    const extension = fileName.split('.').pop().trim().toLowerCase();
    return Object.keys(typeAndSubtype).find((t) => typeAndSubtype[t].fileExtension.includes(extension));
  }
}
